export default "__VITE_PUBLIC_ASSET__81b0e114__"